<template>
    <span>
        <a class="btn btn-primary" @click.prevent.self="execute" :disabled="disabled || IsWorking">
            <i v-show="IsWorking" class="fa fa-refresh fa-spin"></i> {{this.name || "Submit"}}

        </a><ServerErrorHandler v-model="hasServerError" message="There was an issue with the server. Contact Support"></ServerErrorHandler>
    </span>
</template>
<script>
    import Toaster from '../../helpers/Toaster'
    import ServerErrorHandler from "./../../appcontrols/servererrorhandler/servererrorhandler.scp.html";

    export default {
        props: {
            submit: {
                required: true
            },
            callback: {
                required: false
            },
            disabled: {
                required : true
            },
            disableToast: {
                type: Boolean,
                required: false
            },
            task: {
                required: false
            },
            name: {
                required : false
            }
        },
        data: function () {
            return {
                IsWorking: false,
                Text: "Working",
                hasServerError: false
            }
        },
        methods: {
            execute: function () {
                if (this.submit) {
                    this.IsWorking = true;
                    this.$forceUpdate();
                    setTimeout(

                        this.submit().
                            then(status => {
                                this.IsWorking = false;

                                if (status) {
                                    if (!this.disableToast) {
                                        Toaster.Success("Success", this.task)
                                    }
                                    if (this.callback) {
                                        this.callback()
                                    }
                                }
                                else {
                                    this.hasServerError = true;
                                }
                            })
                            .catch(e => {
                                console.log("Error in Worker Button Submit ", e)
                                this.hasServerError = true;
                            })
                        , 500);
                }
            }
        },
        components: {
            ServerErrorHandler
        }
    }
</script>


// WEBPACK FOOTER //
// workerbutton.scp.html?7d0b8e90